import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IIssuerSettings} from "../../../models/IIssuerSettings";
import {fetchGetIssuerSettings, fetchUpsertIssuerSettings} from "./actions";

interface IIssuerSettingsState {
    current: IIssuerSettings | null;
    isLoading: boolean;
}

const initialState: IIssuerSettingsState = {
    current: null,
    isLoading: false,
};

export const IssuerSettingsSlice = createSlice({
    name: "issuer_settings",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                fetchGetIssuerSettings.fulfilled,
                (state, action: PayloadAction<IIssuerSettings | null>) => {
                    state.current = action.payload;
                    state.isLoading = false;
                },
            )
            .addCase(fetchGetIssuerSettings.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchGetIssuerSettings.rejected, (state) => {
                state.isLoading = false;
            })

            .addCase(
                fetchUpsertIssuerSettings.fulfilled,
                (state, action: PayloadAction<IIssuerSettings>) => {
                    state.current = action.payload;
                    state.isLoading = false;
                },
            )
            .addCase(fetchUpsertIssuerSettings.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchUpsertIssuerSettings.rejected, (state) => {
                state.isLoading = false;
            });
    },
});

export default IssuerSettingsSlice.reducer;